import { Link } from 'gatsby';

export default Link;